export default __webpack_public_path__ + "static/media/dots-vertical.9a16611f.svg";